/**
 * V26.5 — Service Worker 注册入口。
 *
 * 只在生产环境注册(dev 模式下 vite HMR 自己管 assets,
 * SW 拦截会干扰 HMR 流;且 dev 是 localhost,没有大 chunk 挂的问题)。
 *
 * 在 4 个 entry(main / platformMain / tenantMain / wecomH5Main)各 import 一次,
 * 注册是 idempotent 的,重复调不出问题。
 */
export function registerSW(): void {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // dev mode 不注册 — vite HMR / mock 等机制会冲突
  if (import.meta.env.DEV) return;

  // 推迟到 load 后注册,避免抢占首屏带宽
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err) => {
      console.warn("[sw] register failed:", err);
    });
  });
}
